import { generatePath, Link } from 'react-router-dom'
import { APPROVALS_PATH, AUTOPILOT_INTEGRATIONS_PATH, CONTENT_PREFERENCES_PATH } from 'paths'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { useModals } from 'almanac-ui/Modal'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { Text } from 'blaze-ui/Text/Text'
import { Close, Approvals, UserProfileAdd2, Images } from 'blaze-ui/icons'
import { ChevronRight } from 'blaze-ui/icons/24'
import { ToolbarMenu } from './ToolbarMenu'
import Styles from './WhatsNewBanner.module.scss'
import { useWhatsNewBannerVisibility } from './useWhatsNewBannerVisibility'
import MediaStrip from 'blaze-ui/icons/20/MediaStrip'

const ITEM_BACKGROUND_COLORS = ['#B64BF814', '#04AF001A', '#FF842B1A', '#4F62F81A'] as const

type WhatsNewItem = {
  id: string
  label: string
  icon: React.ComponentType<{ color?: string; size?: number }>
  iconColor?: string
  to: string
}

export function WhatsNewBanner() {
  const { isVisible, dismiss } = useWhatsNewBannerVisibility()
  const workspace = useCurrentWorkspace()
  const { closeAllModals } = useModals()

  if (!isVisible || !workspace) {
    return null
  }

  const items: WhatsNewItem[] = [
    {
      id: 'integrations',
      label: 'Post to more accounts per platform.',
      icon: UserProfileAdd2,
      iconColor: 'var(--magenta-50)',
      to: generatePath(AUTOPILOT_INTEGRATIONS_PATH, { workspaceId: workspace.id }),
    },
    {
      id: 'approvals',
      label: 'Approve every post before posting.',
      icon: Approvals,
      iconColor: 'var(--green-50)',
      to: generatePath(APPROVALS_PATH, { workspaceId: workspace.id }),
    },
    {
      id: 'visual-styles',
      label: 'Make your brand images look professional.',
      icon: Images,
      iconColor: 'var(--orange-50)',
      to: `${generatePath(CONTENT_PREFERENCES_PATH, { workspaceId: workspace.id })}#image`,
    },
    {
      id: 'video',
      label: 'Add AI videos from your brand images.',
      icon: MediaStrip,
      iconColor: '#4F62F8',
      to: `${generatePath(CONTENT_PREFERENCES_PATH, { workspaceId: workspace.id })}#video`,
    },
  ]

  return (
    <ToolbarMenu
      title="What's new"
      action={<IconButton onPress={dismiss} icon={Close} size="xs" variant="tertiary" aria-label="Dismiss" />}
    >
      <div className={Styles.items}>
        {items.map((item, index) => {
          const Icon = item.icon
          const backgroundColor = ITEM_BACKGROUND_COLORS[index]
          return (
            <Link
              key={item.id}
              to={item.to}
              className={Styles.itemLink}
              onClick={closeAllModals}
            >
              <div className={Styles.item} style={{ backgroundColor }}>
                <span className={Styles.icon}>
                  <Icon color={item.iconColor ?? 'var(--dark-90)'} size={20} />
                </span>
                <Text variant="label" color="var(--dark-90)" className={Styles.itemLabel}>
                  {item.label}
                </Text>
                <ChevronRight color="var(--dark-15)" />
              </div>
            </Link>
          )
        })}
      </div>
    </ToolbarMenu>
  )
}
